export default __webpack_public_path__ + "static/media/quickBooksAccountant.31fc5aef.svg";